// @flow @format
import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import classNames from 'lib/classnames';
import './ProgressBar.css';

type Props = {completed: number, className: string};

class ProgressBar extends PureComponent<Props, void> {
	static propTypes = {
		completed: PropTypes.number.isRequired,
		className: PropTypes.string,
	};

	static defaultProps = {
		className: '',
	};

	render() {
		const {completed, className} = this.props;
		return (
			<div className={classNames('ProgressBar', className)}>
				<span
					className="ProgressBar__Completed"
					style={{width: `${completed}%`}}
				/>
			</div>
		);
	}
}

export default ProgressBar;



// WEBPACK FOOTER //
// ./src/components/ProgressBar/ProgressBar.js